/* global $:true*/

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('SidebarController', SidebarController);

    SidebarController.$inject = [
        '$scope',
        '$window',
        '$state',
        'Auth',
        'Principal',
        'ProfileService',
        '$uibModal',
        'DocumentationUtils'
    ];

    function SidebarController($scope, $window, $state, Auth, Principal, ProfileService, $uibModal, DocumentationUtils) {
        var vm = this;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.toggleSidebar = toggleSidebar;
        vm.openNav = openNav;
        vm.closeNav = closeNav;
        vm.userManualUrl = userManualUrl;
        vm.$state = $state;
        vm.config = {
            theme: 'minimal'
        };
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.knowMore = knowMore;

        function knowMore() {
            $uibModal
                .open({
                    templateUrl: 'app/layouts/footer/know-more/know-more-dialog.html',
                    controller: 'KnowMoreController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md'
                })
                .result.then(
                function() {
                },
                function() {
                }
            );
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('landing-page');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function toggleSidebar() {
            $('#content').toggleClass('active');
            $('#sidebar').toggleClass('active');
            $('#sidebarCollapse').toggleClass('active');
            $('#navbar').toggleClass('active');
        }

        angular.element($window).on('click', function(event) {
            var target = $(event.target);
            var attr = target.attr('id');
            if (
                attr !== 'sidebar' &&
                attr !== 'sidebarCollapse' &&
                !$('#content').hasClass('active') &&
                !isDescendant($('#sidebarCollapse')[0], target[0]) &&
                !isDescendant($('#sidebar')[0], target[0])
            ) {
                toggleSidebar();
            }
        });

        function isDescendant(parent, child) {
            if (!parent || !child) return false;
            var node = child.parentNode;
            while (node != null) {
                if (node === parent) {
                    return true;
                }
                node = node.parentNode;
            }
            return false;
        }

        /*
         * Swipe right-to-left closes the open menu. Only a touch that STARTS on the open sidebar
         * counts: listening on window turned every horizontal gesture on the page (a table scrolled
         * sideways, a carousel) into a menu toggle. There is deliberately no swipe to OPEN - the
         * menu opens from the toggle button only (decision #25, 3 Nov 2026).
         */
        var SWIPE_MIN_PX = 100;
        var swipeStart = null;
        var sidebarElement = document.getElementById('sidebar');

        if (sidebarElement) {
            sidebarElement.addEventListener('touchstart', onSidebarTouchStart, { passive: true });
            sidebarElement.addEventListener('touchend', onSidebarTouchEnd, { passive: true });
            $scope.$on('$destroy', function() {
                sidebarElement.removeEventListener('touchstart', onSidebarTouchStart);
                sidebarElement.removeEventListener('touchend', onSidebarTouchEnd);
            });
        }

        function isSidebarOpen() {
            return !$('#sidebar').hasClass('active');
        }

        function onSidebarTouchStart(event) {
            if (event.touches.length === 1 && isSidebarOpen()) {
                var touch = event.touches.item(0);
                swipeStart = { x: touch.clientX, y: touch.clientY };
            } else {
                swipeStart = null;
            }
        }

        function onSidebarTouchEnd(event) {
            if (!swipeStart) {
                return;
            }
            var touch = event.changedTouches.item(0);
            var dx = touch.clientX - swipeStart.x;
            var dy = touch.clientY - swipeStart.y;
            swipeStart = null;
            // Leftwards, and more sideways than vertical, so scrolling the menu never closes it.
            if (dx < -SWIPE_MIN_PX && Math.abs(dx) > Math.abs(dy)) {
                closeNav();
                $scope.$applyAsync(function() {
                    vm.isNavbarCollapsed = true;
                });
            }
        }

        function openNav() {
            if ($('#sidebar').hasClass('active')) {
                toggleSidebar();
            }
        }

        function closeNav() {
            if (!$('#sidebar').hasClass('active')) {
                toggleSidebar();
            }
        }

        /**
         * The manual is a public page under /content/, not an application state, so it opens
         * in a new tab for everyone, signed in or not. Returned as a URL rather than opened
         * from script so the link stays middle-clickable and copyable.
         */
        function userManualUrl() {
            return DocumentationUtils.userManualUrl();
        }
    }
})();
